import { AccessDeniedPage } from './AccessDenied'

export const AccessDenied = AccessDeniedPage
